var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBackArrow = function SvgBackArrow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 19,
    fill: "#31353B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offers - big card",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    transform: "translate(-23 -98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 7835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 7834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 7814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 7821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 17.5L1 9.5L9 1.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "white",
    transform: "translate(-23 -98)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BackArrow.5519fb10209a8345087c06313b619e96.svg";